// PT-REACT-URLS v1: one place for all server addresses. Values come from .env:
//   REACT_APP_ADMIN_URL  admin panel     (https://admin.pravinbhaitogadia.com/)
//   REACT_APP_API_URL    admin API       (https://admin.pravinbhaitogadia.com/Api/)
//   REACT_APP_SITE_URL   public website  (https://pravinbhaitogadia.com/)
// After changing .env, restart "npm start" or run "npm run build" again.
const withSlash = (value, fallback) => String(value || fallback).replace(/\/+$/, "") + "/";

export const ADMIN_URL = withSlash(process.env.REACT_APP_ADMIN_URL, "https://admin.pravinbhaitogadia.com/");
export const API_URL = withSlash(process.env.REACT_APP_API_URL, ADMIN_URL + "Api/");
export const SITE_URL = withSlash(process.env.REACT_APP_SITE_URL, "https://pravinbhaitogadia.com/");
